import lazyLoading from "./lazyLoading";

export default {
  name: "lab",
  meta: {
    icon: "fa-flask",
    expanded: false,
    label: "Lab",
    superadminOnly: true
  },

  children: [
    {
      name: "commercial-dashboard",
      path: "/admin/commercial-dashboard",
      meta: {
        title: "Dashboard commercial",
        label: "Dashboard commercial"
      },
      component: lazyLoading("commercial-dashboard", true)
    },
    {
      name: "lead-scoring-workspace",
      path: "/admin/lab/lead-scoring/workspace",
      meta: {
        title: "Lead Scoring",
        label: "Lead Scoring",
        superadminOnly: true
      },
      component: lazyLoading("lab/LeadScoringWorkspace", true)
    },
    {
      name: "diderot-shop",
      path: "/preview/prototypes",
      meta: {
        title: "Diderot Shop",
        label: "Diderot Shop",
        external: true
      }
    },
    {
      name: "mobile-app",
      path: "/preview/prototypes/mobile-app/demo.html",
      meta: {
        title: "Mobile App",
        label: "Mobile App",
        external: true
      }
    }
  ]
};
